import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled'
import returnColorByString from '../../component/script/return_color_by_string';

const ItemInfoWrapper = styled.section`
    > header {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        > div {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            min-width: 60px;
            aspect-ratio: 1/1;
            box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.75) inset, 2px 2px 5px 0px rgba(0, 0, 0, 0.05) inset;
            border-radius: 15px;
            img {
                display: block;
                max-width: 100%;
            }
        }
        > article {
            flex: 1 0 auto;
            h2 {
                span {
                    font-size: 12px;
                }
            }
            p {
                display: flex;
                gap: 5px;
                align-items: center;
            }
        }
    }

    >section {
        margin-top: 25px;
    }

    > .item-stat-wrapper {
        ul {
            li {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 10px;
                h3{
                    font-weight: 700;
                    color: var(--color-gray-600);
                    width: 20%;
                    margin-right: 10px;
                }
                p {
                    flex: 1 0 auto;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    span {
                        font-size: 12px;
                        font-weight: 300;
                        &.base{
                            color: var(--color-gray-600);
                            margin-left: 10px;
                        }
                        &.add {
                            color: #5CCC7A;
                        }
                        &.etc {
                            color: #0084E8;
                        }
                        &.starforce {
                            color: #E88A00;
                        }
                    }
                }
            }
        }
    }
    > .symbol-stat-wrapper {
        ul {
            li {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 10px;
                p {
                    width: 50%;
                    color: var(--color-gray-600);
                    font-weight: 700;
                    span {
                        font-size: 12px;
                        margin-left: 10px;
                        font-weight: 300;
                        color: var(--color-black-200);
                    }
                }
            }
        }
    }
    > .potential {
        display: flex;
        margin-top: 25px;
        h3 {
            min-width: 20%;
            margin-right: 10px;
        }
        ul {
            display: flex;
            flex-flow: column;
            gap: 10px;
            li {
                font-weight: 700;
                word-break: keep-all;
            }
        }
    }
    .special-ring {
        margin-top: 25px;
        display: flex;
        justify-content: space-between;
        p {
            font-weight: 700;
            width: 50%;
        }
    }

    .soul {
        margin-top: 25px;
        p {
            margin-top: 10px;
            font-weight: 300;
        }
    }

    .description {
        margin-top: 25px;
    }
    
`

const ITEM_NAME_MATCH = [
    {
        name: "str",
        label: "STR",
        unit: null
    },
    {
        name: "dex",
        label:"DEX",
        unit: null
    },
    {
        name: "int",
        label: "INT",
        unit: null
    },
    {
        name: "luk",
        label: "LUK",
        unit: null
    },
    {
        name: "max_hp",
        label: "HP",
        unit: null
    },
    { name:"max_hp_rate",
        label: "HP",
        unit: "%"
    },
    {
        name: "max_mp",
        label: "MP",
        unit: null
    },
    {
        name: "max_mp_rate",
        label: "MP",
        unit: "%"
    },
    {
        name:"all_stat",
        label:"올스탯",
        unit:"%"
    },
    {
        name: "armor",
        label:"방어력",
        unit: null
    },
    {
        name: "jump",
        label: "점프력",
        unit: null
    },
    {
        name: "speed",
        label: "이속",
        unit: null
    },
    {
        name: "attack_power",
        label:"공격력",
        unit: null
    },
    {
        name: "magic_power",
        label: "마력",
        unit: null
    },
    {
        name: "damage",
        label:"데미지",
        unit: "%"
    },
    {
        name: "boss_damage",
        label:"보공",
        unit: "%"
    },
    {
        name: "ignore_monster_armor",
        label: "방무",
        unit: "%"
    },
    {
        name: "equipment_level_decrease",
        label:"착감",
        unit: null
    },

]

const ItemInfo = ({objectItem})=>{
    const [arrItemObject, setArrItemObject] = useState(null);
    const [arrSymbolStat, setArrSymbolStat] = useState(null);
    useEffect(
        ()=>{
            if(objectItem) {
                if(!objectItem.title_name && !objectItem.android_name && !objectItem.symbol_name){
                    setArrItemObject(
                        ITEM_NAME_MATCH.map(item => {
                            const { name, label, unit } = item;
                        
                            let item_total_option = null;
                            if (objectItem.item_total_option.hasOwnProperty(name)) {
                                item_total_option = objectItem.item_total_option[name];
                            }
                            
                            let item_base_option = null;
                            if (objectItem.item_base_option.hasOwnProperty(name)) {
                                item_base_option = objectItem.item_base_option[name];
                            }
            
                            let item_add_option = null;
                            if (objectItem.item_add_option.hasOwnProperty(name)) {
                                item_add_option = objectItem.item_add_option[name];
                            }
            
                            let item_etc_option = null;
                            if (objectItem.item_etc_option.hasOwnProperty(name)) {
                                item_etc_option = objectItem.item_etc_option[name];
                            }
            
                            let item_starforce_option = null;
                            if (objectItem.item_starforce_option.hasOwnProperty(name)) {
                                item_starforce_option = objectItem.item_starforce_option[name];
                            }
                        
                            return {
                                name,
                                label,
                                unit,
                                item_total_option,
                                item_base_option,
                                item_add_option,
                                item_etc_option,
                                item_starforce_option
                            };
                        })
                    )
                }

                if(objectItem.symbol_name){
                    setArrSymbolStat(
                        [
                            {
                                name: "HP",
                                num: objectItem.symbol_hp,
                            },
                            {
                                name: "STR",
                                num: objectItem.symbol_str,
                            },
                            {
                                name: "DEX",
                                num: objectItem.symbol_dex
                            },
                            {
                                name: "INT",
                                num: objectItem.symbol_int
                            },
                            {
                                name: "LUK",
                                num: objectItem.symbol_luk
                            },
                            {
                                name: "아획",
                                num: objectItem.symbol_drop_rate
                            },
                            {
                                name: "메획",
                                num: objectItem.symbol_meso_rate
                            },
                            {
                                name: "경험치",
                                num: objectItem.symbol_exp_rate
                            }
                        ]
                    )
                }
            }

        },[objectItem]
    )
    
    return(
        <ItemInfoWrapper>
            {
                objectItem?
                objectItem.symbol_name?
                <>
                    <header>
                        <div>
                            <img src={objectItem.symbol_icon} alt="" />
                        </div>
                        <article>
                            <h2>
                                {objectItem.symbol_name}
                            </h2>
                            <p>
                                LV. {objectItem.symbol_level}
                            </p>
                        </article>
                    </header>
                    <section className="symbol-stat-wrapper">
                        <ul>
                            {
                                (objectItem.symbol_name.includes("아케인")&&objectItem.symbol_level===20)
                                || (objectItem.symbol_name.includes("어센틱")&&objectItem.symbol_level===11)?
                                null
                                :<li>
                                <h3>성장경험치</h3>
                                <p>
                                    
                                        {
                                            Math.round((objectItem.symbol_growth_count/objectItem.symbol_require_growth_count)*100)
                                        }
                                        %
                                    <span>
                                        {objectItem.symbol_growth_count} / {objectItem.symbol_require_growth_count}
                                    </span>
                                </p>
                            </li>
                            }
                            <li>
                                <h3>
                                    {
                                        objectItem.symbol_name.includes("아케인")?
                                        "아케인포스":"어센틱포스"
                                    }
                                </h3>
                                <p>
                                    {
                                        objectItem.symbol_force
                                    }
                                </p>
                            </li>
                            {
                                arrSymbolStat?
                                arrSymbolStat.map(
                                    (element, index)=>{
                                        if(element.num === "0" || element.num ==="0%"){
                                            return null
                                        }
                                        return (
                                            <li key={index}>
                                                <h3>{element.name}</h3>
                                                <p>{element.num}</p>
                                            </li>
                                        )
                                    }
                                ):null
                            }
                        </ul>
                    </section>
                </>:
                objectItem.title_name?
                <>
                    <header>
                        <div>
                            <img src={objectItem.title_icon} alt="" />
                        </div>
                        <article>
                            <h2>
                                {objectItem.title_name}
                            </h2>
                        </article>
                    </header>
                    <section className="item-title-android">
                        <pre>{objectItem.title_description}</pre>
                    </section>
                </>
                :objectItem.android_name?                
                <>
                    <header>
                        <div>
                            <img src={objectItem.android_icon} alt="" />
                        </div>
                        <article>
                            <h2>
                                {objectItem.android_name}
                            </h2>
                        </article>
                    </header>
                    <section className="item-title-android">
                        <pre>{objectItem.android_description}</pre>
                    </section>
                </>:objectItem?
                <>
                    <header>
                        <div>
                            <img src={objectItem.item_icon} alt="" />
                            
                        </div>
                        <article>
                            {
                                objectItem.starforce > 0?
                                <p>
                                    <mark>
                                        <img src="/image/icon/icon_starforce_yellow.svg" alt=""/>
                                    </mark>
                                    {objectItem.starforce}
                                </p>:null
                            }
                            <h2>
                                {objectItem.item_name}
                                {objectItem.scroll_upgrade>0?<span> +{objectItem.scroll_upgrade}</span>:null}
                            </h2>
                        </article>
                    </header>
                    <section className="item-stat-wrapper">
                        <ul>
                            {
                                arrItemObject?
                                arrItemObject.map(
                                    (element, index)=>{
                                        if(element.item_total_option > 0){
                                            return(
                                                <li key={index}>
                                                    <h3>{element.label}</h3>
                                                    <p>
                                                        {element.item_total_option} {element.unit}
                                                        
                                                        {element.item_base_option === element.item_total_option ?null:<span className="base">{element.item_base_option} {element.unit}</span>}
                                                        
                                                        {element.item_add_option > 0?<span className="add">+ {element.item_add_option} {element.unit}</span>:null}
                                                        
                                                        {element.item_etc_option > 0?<span className="etc">+ {element.item_etc_option} {element.unit}</span>:null}
                                                        
                                                        {element.item_starforce_option > 0?<span className="starforce">+ {element.item_starforce_option} {element.unit}</span>:null}
                                                        
                                                    </p>
                                                </li>
                                            )
                                        }
                                        return null
                                        
                                    }
                                ):null
                            }
                            
                        </ul>
                        
                    </section>
                    {
                        objectItem.potential_option_grade?
                        <section className="potential up" style={{color:returnColorByString(objectItem.potential_option_grade)}}>
                            <h3>
                                {objectItem.potential_option_grade}
                            </h3>
                            <ul>
                                {objectItem.potential_option_1?<li>{objectItem.potential_option_1}</li>:null}
                                {objectItem.potential_option_2?<li>{objectItem.potential_option_2}</li>:null}
                                {objectItem.potential_option_3?<li>{objectItem.potential_option_3}</li>:null}
                            </ul>
                        </section>:null
                    }
                    {
                        objectItem.additional_potential_option_grade?
                        <section className="potential bottom" style={{color:returnColorByString(objectItem.additional_potential_option_grade)}}>
                            <h3>
                                {objectItem.additional_potential_option_grade}
                            </h3>
                            <ul>
                                {objectItem.additional_potential_option_1?<li>{objectItem.additional_potential_option_1}</li>:null}
                                {objectItem.additional_potential_option_2?<li>{objectItem.additional_potential_option_2}</li>:null}
                                {objectItem.additional_potential_option_3?<li>{objectItem.additional_potential_option_3}</li>:null}
                            </ul>

                        </section>:null
                    }
                    {
                        objectItem.soul_name?
                        <section className="soul">
                            <h3>
                                {objectItem.soul_name}
                            </h3>
                            <p>
                                {objectItem.soul_option}
                            </p>
                        </section>:null
                    }
                    {
                        objectItem.special_ring_level?
                        <section className="special-ring">
                            <h3>
                                특수 스킬 반지 레벨
                            </h3>
                            <p>
                                {objectItem.special_ring_level}
                            </p>
                             
                        </section>:null
                    }
                    {
                        objectItem.item_description?
                        <section className="description">
                            <pre>
                                {
                                    objectItem.item_description
                                }
                            </pre>
                        </section>:null
                    }
                    
                </>
                :null
                :null
            }

        </ItemInfoWrapper>
    )
}


export default ItemInfo;